const defaultFilterOn = (record) => record.active

const recordActive = (filterOn) => (record) => (
  Object.assign(
    {...record},
    {
      inactive: !filterOn(record)
    }
  )
)
const filterBy = (filterOn) => (record) => filterOn(record)

export const filterRecords = (records = [], isFiltering = true, filterOn = defaultFilterOn) => (
  isFiltering ?
    records.filter(filterBy(filterOn)) :
    records.map(recordActive(filterOn))
)



// WEBPACK FOOTER //
// ./src/ui/active-filter/filter.jsx